// extracted by mini-css-extract-plugin
export default {"round":"styles_round__paREH","round__table":"styles_round__table__GMpnW"};